export const ddmmmyyyy = (date) => {
  return new Date(date).toLocaleString("en-UG", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};
export const hhmmss = (sec) => {
  console.log({ sec });
  sec = Math.trunc(sec);
  const secNum = parseInt(sec, 10);
  let hours = Math.floor(secNum / 3600);
  let minutes = Math.floor((secNum - hours * 3600) / 60);
  let seconds = secNum - hours * 3600 - minutes * 60;

  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;

  return hours + ":" + minutes + ":" + seconds;
};
